/**
 * Validação e conversão do formulário da etapa 1 do cadastro de instalação elétrica.
 */
import {
  ELECTRICAL_INSTALLATION_TYPES,
  type ElectricalInstallationCreateData,
} from '../../../../types/electricalInstallation';
import type { IdentificationErrors, IdentificationValues } from './ElectricalInstallationWizard.types';

const blankToNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
};

export function validateIdentification(
  values: IdentificationValues,
  requiresCompany = false
): IdentificationErrors {
  const errors: IdentificationErrors = {};

  if (requiresCompany && values.companyId === '') errors.companyId = 'Escolha a empresa dona da instalação.';

  if (values.name.trim() === '') errors.name = 'Diga o nome da instalação.';
  else if (values.name.trim().length > 200) errors.name = 'O nome pode ter até 200 letras.';

  if (values.tag.length > 100) errors.tag = 'Use até 100 letras.';
  if (values.location.length > 255) errors.location = 'Use até 255 letras.';

  if (!ELECTRICAL_INSTALLATION_TYPES.includes(values.installationType)) {
    errors.installationType = 'Escolha um tipo da lista.';
  } else if (values.installationType === 'OUTRA' && values.typeDescription.trim() === '') {
    errors.typeDescription = 'Descreva o tipo, porque você escolheu "Outra".';
  }

  if (values.nominalVoltage.trim() !== '') {
    const volts = Number(values.nominalVoltage);
    if (!Number.isInteger(volts) || volts <= 0) {
      errors.nominalVoltage = 'Informe a tensão em volts, só com números inteiros. Ex.: 380';
    }
  }

  return errors;
}

/** `includeCompany` é falso na atualização: a empresa dona não muda depois que a instalação é salva. */
export function identificationToPayload(values: IdentificationValues, includeCompany = true): ElectricalInstallationCreateData {
  return {
    ...(!includeCompany || values.companyId === '' ? {} : { companyId: Number(values.companyId) }),
    name: values.name.trim(),
    tag: blankToNull(values.tag),
    installationType: values.installationType,
    typeDescription: values.installationType === 'OUTRA' ? values.typeDescription.trim() : null,
    nominalVoltage: values.nominalVoltage.trim() === '' ? null : Number(values.nominalVoltage),
    location: blankToNull(values.location),
    departmentId: values.departmentId === '' ? null : Number(values.departmentId),
    status: values.status,
    observations: blankToNull(values.observations),
  };
}

export function errorMessage(err: unknown, fallback: string): string {
  return err instanceof Error ? err.message : fallback;
}
